/*
 * <tdg-add-to-cart data-items='[{"id":123,"quantity":1}]'>
 *   <button type="button">...</button>
 *   <p class="tdg-atc__error" hidden></p>
 * </tdg-add-to-cart>
 *
 * Adds one or more variants to the cart and refreshes Dawn's cart drawer
 * (falls back to redirecting to /cart when the drawer isn't on the page).
 */
if (!customElements.get('tdg-add-to-cart')) {
  customElements.define(
    'tdg-add-to-cart',
    class TdgAddToCart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.errorEl = this.querySelector('.tdg-atc__error');
        if (!this.button) return;
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      async onClick(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-busy') === 'true') return;

        let items;
        try {
          items = JSON.parse(this.dataset.items || '[]');
        } catch (e) {
          items = [];
        }
        if (!items.length) return;

        this.setLoading(true);
        this.showError('');

        const cart = document.querySelector('cart-drawer');
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            this.showError(data.description || data.message || 'No se pudo agregar. Intenta de nuevo.');
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
          cart.renderContents(data);
        } catch (e) {
          this.showError('Error de conexión. Intenta de nuevo.');
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.button.classList.toggle('loading', isLoading);
        this.button.disabled = isLoading;
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }
    }
  );
}
